/*
  COTANTIN よくあるご質問（sections/cotantin-faq-page.liquid）。
  いま見ているカテゴリを、PC の目次とスマホのタブで墨にする。
  判定はスクロール位置から：見出しが画面の上から 30% の線より上にある最後のカテゴリ（無ければ最初のカテゴリ）。
  スマホのタブは、現在地が見えるように横にスクロールする。リンク自体はふつうのページ内リンク（CSS の scroll-margin で位置を合わせる）。
*/
(function () {
  function init() {
    var cats = Array.prototype.slice.call(document.querySelectorAll('[data-cf-cat][id]'));
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-cf-link]'));
    if (!cats.length || !links.length) return;
    var tabs = document.querySelector('[data-cf-tabs] .cf-tabs__list');
    var current = null;
    var ticking = false;

    function setCurrent(id) {
      if (id === current) return;
      current = id;
      links.forEach(function (a) {
        var on = a.getAttribute('data-cf-link') === id;
        a.classList.toggle('is-current', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      if (tabs) {
        var tab = tabs.querySelector('[data-cf-link="' + id + '"]');
        if (tab) {
          var left = tab.offsetLeft - tabs.offsetLeft;
          if (left < tabs.scrollLeft || left + tab.offsetWidth > tabs.scrollLeft + tabs.clientWidth - 40) {
            tabs.scrollTo({ left: Math.max(0, left - 16), behavior: 'smooth' });
          }
        }
      }
    }

    function update() {
      ticking = false;
      var line = window.innerHeight * 0.3;
      var id = cats[0].id;
      for (var i = 0; i < cats.length; i++) {
        if (cats[i].getBoundingClientRect().top <= line) id = cats[i].id; else break;
      }
      // ページの最後まで来たら最後のカテゴリ（短いカテゴリが線に届かないため）
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
        var last = cats[cats.length - 1];
        if (last.getBoundingClientRect().top < window.innerHeight) id = last.id;
      }
      setCurrent(id);
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    // ページ内リンクはなめらかにスクロール
    links.forEach(function (a) {
      a.addEventListener('click', function (event) {
        var target = document.getElementById(a.getAttribute('data-cf-link'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + target.id);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
